import type { CSSProperties } from "react";

/** Readable CPA configured state (avoids low-contrast white on solid green). */
export const CPA_CONFIGURED_TAG_STYLE: CSSProperties = {
  marginInline: 0,
  color: "#005c38",
  backgroundColor: "#e6f4ee",
  borderColor: "#009e60",
  fontWeight: 600,
};
